import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PaymentSuccessIcon from "../../assets/img/Transaction-Approved.svg";
import User from "../../services/user.service";
import Storage from '../../services/storage.service';
import GTMService from "../../services/gtm.service";
import DownloadAppLinks from '../../ui/download_app_links';
import Settings from '../../services/settings.service';
import FirebaseAnalytics from '../../services/analytics.service';
import CONSTANTS from '../../services/constants.service';
import SpinnerTimeLoader from '../shared/timeLoading';
import Flow from '../../services/flow.service';
const subscriptions = [];
const PaymentSuccess = props => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [loader, setLoader] = useState(false);
    // const [summeryRes, setSummeryRes] = useState({});

    const paymentHandling = () => {
        FirebaseAnalytics.button_clicked(CONSTANTS.PAYMENT_SUCCESS_SCREEN, "buttons_continue");
        setLoader(true);
        User.fetchFlowStatus().then(() => {
            Flow.goTo();
            Storage.clear("paymentSuccess");
            Storage.clear("paymentPrice")
            setLoader(false);
        })

    }
    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        GTMService.action_gtm_on_payment_done();
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);

    return (<div className="payment-summary-main summary-main">
        {loader ? <SpinnerTimeLoader /> :
            <div className="summary-wrapper">
                <div className="summary-right-col">
                    <div className="payment-summary">
                        <div>
                            <img src={PaymentSuccessIcon} alt={translationKeys["payment_completed_successfully"]}></img>
                        </div>
                        <div className='payment-success-title'>
                            {translationKeys["payment_completed_successfully"]}
                        </div>
                        <div className='payment-success-desc'>
                            {translationKeys["payment_success_desc"]}
                        </div>
                        <div className="buttons-confirm success-continue" >
                            <button className="pay_now_btn" onClick={paymentHandling}> {translationKeys["buttons_continue"]}</button>
                        </div>
                        <p className='download-app'>{translationKeys["payment_download_app"]}</p>
                        <DownloadAppLinks
                            classes={"download-app-container-btns-area"}
                            google_play_link={Settings.google_play_link}
                            app_store_link={Settings.app_store_link}
                            huawei_store_link={Settings.huawei_store_link}
                        />
                    </div>
                </div>
            </div>
        }
    </div>
    )
}

export default PaymentSuccess;